export const PATIENT_SELECTOR_ALL = 'all'
export const PATIENT_SELECTOR_MY_PATIENTS = 'my'
export const PATIENT_SELECTOR_SUPERVISED_PATIENTS = 'supervised'
export const PATIENT_SELECTOR_ALL_LABEL = 'allPatients'
export const PATIENT_SELECTOR_MY_PATIENTS_LABEL = 'myPatients'
export const PATIENT_SELECTOR_SUPERVISED_PATIENTS_LABEL = 'supervisedClinicianPatients'
export const PATIENT_SELECTOR_ALL_RESPONDENTS = 'allRespondents'
export const PATIENT_SELECTOR_MY_RESPONDENTS = 'myRespondents'
export const PATIENT_SELECTOR_SUPERVISED_RESPONDENTS = 'supervisedClinicianRespondents'
